import withReorderPathItems from "@pathwright/web/src/modules/path/graphql/withReorderPathItems"
import { handlePathItemDragEnd } from "@pathwright/web/src/modules/path/utils"
import React, { useContext, useState } from "react"
import { DragDropContext } from "react-beautiful-dnd"

export const DragDropPathItemsContext = React.createContext()

export const useDragDropPathItemsContext = () =>
  useContext(DragDropPathItemsContext)

export const withIsDragging = (Component) => (props) => {
  const context = useDragDropPathItemsContext()
  return (
    <Component {...props} isDragging={context ? context.isDragging : false} />
  )
}

const DragDropPathItems = ({
  items, // nested shape (i.e. not flat)
  children,
  reorderPathItems
}) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragStart = () => setIsDragging(true)

  const handleDragEnd = async (result) => {
    setIsDragging(false)
    const pathItems = handlePathItemDragEnd(result, items)

    if (pathItems) {
      // reorder path items based on new pathItems structure
      await reorderPathItems(pathItems)
      // update publish button
      App.getStore("path").storeTrigger("path:items:reordered")
    }
  }

  return (
    <DragDropPathItemsContext.Provider value={{ isDragging: isDragging }}>
      <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
        {children}
      </DragDropContext>
    </DragDropPathItemsContext.Provider>
  )
}

DragDropPathItems.displayName = "DragDropPathItems"

export default withReorderPathItems(DragDropPathItems)
